import React, { memo } from "react";
import { Link } from "react-router-dom";
import { Button, Stack } from "@mui/material";

import { useAppSelector } from "../../../../store/hooks";
// import {
//   AmazonFill,
//   EMangnifier,
//   GoogleRe,
//   ShopBag,
//   Spin,
// } from "../../../../utils";
import { selectProductDetail } from "../../../../features/productAnalyzer/productAnalyzer.selector";

const Marketplaces: React.FC = () => {
  const { productDetail } = useAppSelector(selectProductDetail);

  if (!productDetail) return null;

  return (
    <Stack
      position={"relative"}
      padding={"4px 4px"}
      direction={"row"}
      rowGap={"4px"}
      columnGap={"4px"}
      flexWrap={"wrap"}
    >
      <Button
        variant="outlined"
        sx={{ backgroundColor: "#EFF6FF", border: "solid 1px #0F56CA80" }}
        component={Link}
        to={`https://www.ebay.com/sch/i.html?_nkw=${productDetail.upc || productDetail.title}`}
        target="_blank"
        disabled={
          !productDetail || (!productDetail.upc && !productDetail.title)
        }
      >
        {/* <img src={EMangnifier} alt="Search eBay icon" />&nbsp; */}
        Search eBay
      </Button>

      <Button
        variant="outlined"
        sx={{ backgroundColor: "#EFF6FF", border: "solid 1px #0F56CA80" }}
        component={Link}
        to={`https://www.ebay.com/sch/i.html?_nkw=${productDetail.upc || productDetail.title}&LH_Sold=1`}
        target="_blank"
        disabled={
          !productDetail || (!productDetail.upc && !productDetail.title)
        }
      >
        {/* <img src={ShopBag} alt="Sold on eBay icon" />&nbsp; */}
        Sold on eBay
      </Button>

      <Button
        variant="outlined"
        sx={{ backgroundColor: "#EFF6FF", border: "solid 1px #0F56CA80" }}
        component={Link}
        to={`https://walmart.com/search?q=${encodeURIComponent(
          productDetail.title || "",
        )}`}
        target="_blank"
        disabled={!productDetail || !productDetail.title}
      >
        {/* <img src={Spin} alt="Search Walmart icon" />&nbsp; */}
        Search Walmart
      </Button>

      <Button
        variant="outlined"
        sx={{ backgroundColor: "#EFF6FF", border: "solid 1px #0F56CA80" }}
        component={Link}
        to={`https://www.google.com/search?q=${encodeURIComponent(
          productDetail.title,
        )}`}
        target="_blank"
        disabled={!productDetail || !productDetail.title}
      >
        {/* <img src={GoogleRe} alt="Search Google icon" />&nbsp; */}
        Search Google
      </Button>

      <Button
        variant="outlined"
        sx={{ backgroundColor: "#EFF6FF", border: "solid 1px #0F56CA80" }}
        component={Link}
        to={`https://www.amazon.com/dp/${productDetail.asin}`}
        target="_blank"
        disabled={!productDetail}
      >
        {/* <img src={AmazonFill} alt="Search Amazon icon" />&nbsp; */}
        Search Amazon
      </Button>

      <Button
        variant="outlined"
        sx={{ backgroundColor: "#EFF6FF", border: "solid 1px #0F56CA80" }}
        component={Link}
        to={`https://keepa.com/#!product/1-${productDetail.asin}`}
        target="_blank"
        disabled={!productDetail || !productDetail.asin}
      >
        Keepa
      </Button>
    </Stack>
  );
};

export default memo(Marketplaces);
